import type { TemplateChartSettings } from "connected-components/dashboard/store/template-chart-settings"

// Per-template chart-settings keys + defaults. Keys are the slice's templateCharts map keys;
// defaults apply when no value is stored.

export const FACTORS_VIEW_PERFORMANCE_TEMPLATE_KEY = "performance"
export const FACTORS_VIEW_PERFORMANCE_DEFAULTS: TemplateChartSettings = {
  selectedMetricDisplay: "cumulativePercent",
}

export const FACTORS_VIEW_CONTENT_SET_TEMPLATE_KEY = "content-set"
export const FACTORS_VIEW_CONTENT_SET_DEFAULTS: TemplateChartSettings = {
  selectedCategory: null,
}
